import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import CompressPDFCompressListScreen from "./CompressPDFCompressListScreen";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";

function CompressPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Compress PDF files" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/compress_pdf", title: "Reduce PDF size" },
    data2: { link: "/compress_pdf", title: "PDF Compressor" },
    data3: { link: "/compress_pdf", title: "Shrink PDF" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Compress PDF online instantly. Reduce PDF file size, save storage, and share documents quickly with our fast, secure, and easy PDF compressor."
      ></meta>
      <meta
        name="keywords"
        content="compress PDF, PDF compressor, reduce PDF size, compress PDF online, online PDF compressor, shrink PDF files, PDF size reducer, compress large PDF, PDF optimization tool, PDF file shrinker, compress PDF for email, PDF file compression, PDF editor online, PDF management tool, compress documents"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <CompressPDFCompressListScreen title={title} />
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Offline PDF Compressor Tool is a powerful and reliable solution designed for users who need to compress PDF files offline without relying on an internet connection, making it ideal for professionals, businesses, and individuals who value speed, privacy, and full control over their documents. This advanced PDF compressor software allows you to reduce PDF file size, compress large PDF documents, and optimize files for storage, email, and sharing while preserving original layout, text clarity, and image quality. Unlike online tools, this offline PDF compression tool processes files directly on your device, ensuring maximum data security and complete privacy, which is especially important for confidential contracts, financial reports, and legal documents. With intelligent compression algorithms, the tool efficiently shrink PDF size without losing quality, remove unnecessary metadata, and improve document performance across all platforms. Compatible with Windows, macOS, and other desktop environments, this best offline PDF compressor offers fast processing, batch compression support, and an easy-to-use interface with no file size limits or upload restrictions. Whether you need to compress PDFs for email, save disk space, or optimize documents for professional use, this secure offline PDF compressor tool delivers high-performance PDF optimization anytime, anywhere, without internet dependency." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Compress",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Compress PDF"
            why_use={[
              {
                title: "Size",
                description:
                  "Compress pdfs to share, upload and store them efficiently. Save plenty of spaces on your drive just by compressing your document files.",
              },
              {
                title: "Quality",
                description:
                  "Compress pdf documents without degrading quality. Save space without compromising on quality.",
              },
              {
                title: "Privacy & Protect",
                description:
                  "You documents are protected through our high level encryption and deleted immediately after compression.",
              },

              {
                title: "Students & Professionals",
                description:
                  "Students and Professionals can manage files more easily and efficiently using PDF compressor.",
              },
              {
                title: "Compress other files",
                description:
                  "Not only PDFs. You can also compress other file formats (Word, Excel, PPT etc) using our app.",
              },
              {
                title: "Quick & Easy",
                description:
                  "Save your time as this app is quick and easy to use, just select file and convert it.",
              },
              {
                title: "Free to use",
                description:
                  "You don't need any account or sign up to start using our service. Very little time required to get your jobs done and the great part is it is free to use. And our app works completely offline.",
              },
              {
                title: "Bulk Conversion",
                description:
                  "Compress multiple pdf files at once and save time using the premium version of this app.",
              },
              {
                title: "Under 200KB",
                description:
                  "Many online forms require PDF files to be 200KB or smaller. With this PDF compressor, you can easily reduce your PDF size to under 200KB.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1609168763}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default CompressPDFMain;
